module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cvi.htm"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "also"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/also.htm"
    }
  }, [_vm._v("Also by Yan Lianke")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/tp.htm"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/cop.htm"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "fm"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/fm.htm"
    }
  }, [_vm._v("Translator’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("CHAPTER 1: Prefatory Material")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("CHAPTER 2: Geographic Transformation (1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("CHAPTER 3: Year One of the Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("CHAPTER 4: Revolutionary Biographies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("CHAPTER 5: Political Power (1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c06"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("CHAPTER 6: Traditional Customs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c07"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("CHAPTER 7: Political Power (2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c08"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("CHAPTER 8: Integrated Economy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c09"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("CHAPTER 9: Nature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("CHAPTER 10: Structural Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("CHAPTER 11: Assessment of the New Era")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("CHAPTER 12: National Defense")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_vm._v("CHAPTER 13: The Post-Military Era")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("CHAPTER 14: Geographic Transformation (2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("CHAPTER 15: Culture, Cultural Relics, and History")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_vm._v("CHAPTER 16: New Members of the Clan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c17.htm"
    }
  }, [_vm._v("CHAPTER 17: Great Geographic Transformation (1)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c18.htm"
    }
  }, [_vm._v("CHAPTER 18: Great Geographic Transformation (2)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "c19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/c19.htm"
    }
  }, [_vm._v("CHAPTER 19: Postface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "aun"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/aun.htm"
    }
  }, [_vm._v("Author’s Note")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 75
// module chunks = 0